/* ============================================================================
   v2-entreprise.js — l'espace entreprise (/pages/entreprise ET /pages/compte)
   ----------------------------------------------------------------------------
   Cree le 2026-09-03 (v2-concession.js), renomme le meme jour. Sert
   snippets/v2-p-entreprise-espace.liquid (client connecte ET rattache :
   `window.SA_CLIENT.concession`), rendu par /pages/entreprise pour le
   concessionnaire et par /pages/compte pour une flotte ou un bureau
   (Alex, 2026-09-08 : « il peut reserver sur la page mon compte »).

   DEUX GRILLES, UN MOTEUR (2026-09-08). Le type d'entreprise decide :
   - concessionnaire : Remise a neuf / Livraison, verrou 60 jours, -25 $ depot ;
   - flotte / bureau : le forfait ENTRETIEN du site (feuille bureaux du
     2026-08-24 = PRIX-ET-DUREES section Entretien) — mise a niveau une fois
     (Int&Ext 350 $ / Ext 125 $), puis passages au rythme du vehicule (mensuel
     200 / 60 $, aux 2 mois 250 / 80 $), plus un passage ponctuel Bronze /
     Argent / Or au prix plein entre deux cycles. Aucun rabais de groupe. Le
     rabais depot (dollars fixes par formule) et la fenetre de passage
     (passageMaxJours) viennent de booking_config.entreprise, puis des
     `regles` que le postier renvoie — jamais d'un chiffre ecrit ici.
     Le postier v5 applique les memes regles a l'ecriture.
   HORAIRE (Alex, 2026-09-08) : une flotte ou un bureau reserve COMME UN CLIENT —
     une journee ET une heure de depot, un vehicule a la fois, plage bloquee
     dans l'horaire (rendez-vous NON flottant). Les creneaux viennent de
     `SA_BOOKING.creneaux`, exposes ce jour : l'heure offerte est celle qu'un
     particulier verrait. Seul le concessionnaire garde la journee flottante
     au budget d'heures-personne.

   CE FICHIER NE CALCULE PAS LA CAPACITE. Il la demande a `window.SA_BOOKING`,
   le moteur du panneau public (assets/v2-booking.js) expose sans panneau.
   Une journee est offerte si — et seulement si — le meme moteur dirait au
   grand public qu'il reste assez d'heures-personne pour tout le lot.

   CE FICHIER NE CHOISIT PAS LA CONCESSION. Il envoie le numero du client et
   son courriel ; le postier relit la fiche et decide. Un lot pour une autre
   concession est refuse la-bas, pas ici.

   LES PRIX. Table PRIX ci-dessous, source : feuille concessionnaire
   (supports-vente/2-feuille-concessionnaire.html), tranchee par Alex le
   2026-09-03 — Remise a neuf 300 $, Livraison 150 $, berline ; VUS +25 $,
   camionnette / 7 places +50 $ ; depot -25 $ par vehicule. Le montant part au
   postier comme information (« annonce »), jamais comme verite de facturation :
   le releve mensuel se fait dans l'app.

   RENDEZ-VOUS FLOTTANTS (decision d'Alex, 2026-09-03) : le concessionnaire
   choisit une JOURNEE. Le postier ecrit un rendez-vous par vehicule, a l'heure
   d'ouverture, marque flottant : il consomme les heures-personne du jour mais
   ne barre aucune plage pour le grand public.
   ============================================================================ */
(function () {
  "use strict";

  var C = window.SA_CLIENT;
  var B = window.SA_BOOKING;
  /* La racine est le snippet partage (data-cc-espace), sur l'une ou l'autre page. */
  var racine = document.querySelector('[data-cc-espace]') || document.querySelector('main[data-page="concession"]');
  if (!racine || !C || !C.connecte || !C.concession) return;
  if (!B || !B.cfg) {
    montrerErreur("Le moteur de réservation n'a pas chargé. Rechargez la page, ou appelez-nous au 418 808-6352.");
    return;
  }

  /* ================= Constantes ================= */

  /* Source : feuille concessionnaire du 2026-09-03 (D1). Berline. */
  var PRIX = { cc_remise: 300, cc_livraison: 150 };
  var SUPP = { berline: 0, vus: 25, camionnette: 50 };
  var RABAIS_DEPOT = 25;
  var NOMS = { cc_remise: "Remise à neuf", cc_livraison: "Livraison" };

  /* ---- Entretien flotte / bureau (2026-09-08) ----
     Source : feuille bureaux du 2026-08-24 (supports-vente/5-feuille-bureaux.html)
     = PRIX-ET-DUREES section Entretien. Berline ; supplement SUPP par passage. */
  /* ---- PLUSIEURS ENTREPRISES SUR UN COURRIEL (Alex, 2026-09-08) -----------
     `ma_concession` est une LISTE depuis le chantier A. Un courriel peut servir
     plusieurs entreprises : les deux vitrines de demonstration aujourd'hui, les
     deux succursales d'un groupe demain. Ce ne sont plus deux cas — c'est le
     meme.

     `SA_CLIENT.entreprises` porte la liste ; `SA_CLIENT.concession` porte la
     premiere, celle que Liquid a deja rendue dans l'en-tete. `?entreprise=`
     nomme celle qu'on veut par son handle. Le postier applique la MEME regle a
     l'ecriture : appartenir a la liste suffit, donc reserver marche dans
     n'importe laquelle. Aucune exception nulle part.
     ------------------------------------------------------------------------ */
  var ENTREPRISES = (C.entreprises && C.entreprises.length) ? C.entreprises : (C.concession ? [C.concession] : []);
  var DEFAUT = C.concession;

  function parametre(nom) {
    var m = new RegExp("[?&]" + nom + "=([^&#]*)").exec(window.location.search);
    return m ? decodeURIComponent(m[1]).toLowerCase() : "";
  }

  /* L'identifiant dans l'URL : le handle quand Liquid le rend, sinon le numero
     du GID. Le handle est plus lisible, mais y accrocher la seule cle du
     selecteur le rendait muet le jour ou il revenait vide — la barre
     s'affichait, les boutons ne faisaient rien. Le GID, lui, est toujours la :
     c'est deja lui qu'on envoie au postier. */
  function cleDe(e) {
    if (!e) return "";
    var h = String(e.handle || "").trim();
    if (h) return h.toLowerCase();
    return String(e.gid || "").split("/").pop().toLowerCase();
  }

  var demande = ENTREPRISES.length > 1 ? parametre("entreprise") : "";
  var choisie = null;
  for (var ie = 0; ie < ENTREPRISES.length && demande; ie++) {
    var e0 = ENTREPRISES[ie];
    /* On accepte les deux formes : une URL collee hier avec un handle marche
       encore si le handle revient, et le numero marche toujours. */
    if (cleDe(e0) === demande || String(e0.gid || "").split("/").pop().toLowerCase() === demande) {
      choisie = e0; break;
    }
  }
  /* Une demande qui ne correspond a rien retombe sur l'entreprise par defaut :
     la seule facon d'en poser une est de bricoler une URL, et retomber sur le
     comportement normal vaut mieux qu'un ecran d'erreur. */
  var AUTRE = !!(choisie && choisie.gid && DEFAUT && choisie.gid !== DEFAUT.gid);
  if (AUTRE) C.concession = choisie;

  /* Temoin de diagnostic. Ce selecteur a deja echoue en silence — la barre
     s'affichait, cliquer ne changeait rien, et rien nulle part ne disait
     pourquoi. Une ligne dans la console coute zero et repond en trois
     secondes : combien d'entreprises, ce qui a ete demande, ce qui a ete
     trouve, et ce qui part au postier. */
  try {
    console.log("[SA entreprises]", {
      combien: ENTREPRISES.length,
      cles: ENTREPRISES.map(cleDe),
      demande: demande,
      trouvee: choisie ? choisie.nom : null,
      autre: AUTRE,
      affichee: C.concession && C.concession.nom,
      envoieAuPostier: AUTRE ? C.concession.gid : "(rien — entreprise par defaut)"
    });
  } catch (e) { /* la console n'est jamais essentielle */ }

  var TYPE = String(C.concession.type || "concessionnaire").toLowerCase();
  var ENTRETIEN = TYPE !== "concessionnaire";
  var PRIX_ENT = { maj: { int_ext: 350, ext: 125 }, mensuel: { int_ext: 200, ext: 60 }, "2mois": { int_ext: 250, ext: 80 } };
  /* Le ponctuel : les neuf forfaits du site, prix plein (memes montants que
     /pages/forfaits et le verso de la feuille bureaux). */
  var PRIX_PONCTUEL = { ext_bronze: 125, ext_argent: 175, ext_or: 275, int_bronze: 275, int_argent: 325, int_or: 400, both_bronze: 350, both_argent: 475, both_or: 625 };
  var NOMS_PONCTUEL = { ext_bronze: "Extérieur Bronze", ext_argent: "Extérieur Argent", ext_or: "Extérieur Or",
    int_bronze: "Intérieur Bronze", int_argent: "Intérieur Argent", int_or: "Intérieur Or",
    both_bronze: "Int & Ext Bronze", both_argent: "Int & Ext Argent", both_or: "Int & Ext Or" };
  var NOMS_FORMULE = { int_ext: "Int & Ext", ext: "Extérieur" };
  var NOMS_RYTHME = { mensuel: "chaque mois", "2mois": "aux 2 mois" };
  /* Les regles : config du site d'abord (v13), puis ce que le postier renvoie
     (regles de concession_etat) — la deuxieme source prime, c'est elle qui
     refusera a l'ecriture. */
  /* v14 (Alex, 2026-09-08) : le DEPOT est l'option par defaut, au prix du
     site ; la CUEILLETTE est un supplement par vehicule. Le rabais depot de
     la v13 est mort (garde a 0 dans la config pour les vieux lecteurs). */
  var REGLES = { passageMaxJours: 75, rabaisDepot: { int_ext: 0, ext: 0 }, transportDefaut: "depot", supplementCueillette: 10 };
  function lireRegles(e) {
    if (!e) return;
    if (parseInt(e.passageMaxJours, 10) > 0) REGLES.passageMaxJours = parseInt(e.passageMaxJours, 10);
    if (e.rabaisDepot) {
      if (e.rabaisDepot.int_ext != null) REGLES.rabaisDepot.int_ext = +e.rabaisDepot.int_ext;
      if (e.rabaisDepot.ext != null) REGLES.rabaisDepot.ext = +e.rabaisDepot.ext;
    }
    if (e.transportDefaut === "cueillette" || e.transportDefaut === "depot") REGLES.transportDefaut = e.transportDefaut;
    if (e.supplementCueillette != null) REGLES.supplementCueillette = +e.supplementCueillette;
  }
  lireRegles(B.cfg.entreprise);

  /* Ce qu'une cle de forfait dit d'elle-meme, cote entretien. Copie fidele de
     decrireForfaitEntretien() du postier : les deux doivent dire la meme chose. */
  function decrire(f) {
    if (f === "both_bronze") return { genre: "maj", formule: "int_ext" };
    if (f === "ext_bronze")  return { genre: "maj", formule: "ext" };
    if (f === "ent_1mois")     return { genre: "passage", formule: "int_ext", rythme: "mensuel" };
    if (f === "ent_2mois")     return { genre: "passage", formule: "int_ext", rythme: "2mois" };
    if (f === "ent_ext_1mois") return { genre: "passage", formule: "ext", rythme: "mensuel" };
    if (f === "ent_ext_2mois") return { genre: "passage", formule: "ext", rythme: "2mois" };
    var p = String(f).split("_");
    if (["both", "int", "ext"].indexOf(p[0]) !== -1 && ["bronze", "argent", "or"].indexOf(p[1]) !== -1) {
      return { genre: "ponctuel", formule: p[0] === "int" ? "int" : (p[0] === "both" ? "int_ext" : "ext") };
    }
    return null;
  }
  function cleDePassage(formule, rythme) {
    return (formule === "ext" ? "ent_ext_" : "ent_") + (rythme === "2mois" ? "2mois" : "1mois");
  }
  function nomForfait(f) {
    if (NOMS[f]) return NOMS[f];
    var d = decrire(f);
    if (!d) return f;
    if (d.genre === "maj") return "Mise à niveau " + NOMS_FORMULE[d.formule];
    if (d.genre === "passage") return "Passage " + NOMS_RYTHME[d.rythme] + " · " + NOMS_FORMULE[d.formule];
    return "Ponctuel · " + (NOMS_PONCTUEL[f] || f);
  }
  function rabaisDepotDe(f) {
    if (!ENTRETIEN) return RABAIS_DEPOT;
    var d = decrire(f);
    if (!d || d.genre === "ponctuel") return 0;
    return d.formule === "ext" ? REGLES.rabaisDepot.ext : REGLES.rabaisDepot.int_ext;
  }
  var FORMATS = { berline: "Berline", vus: "VUS", camionnette: "Camionnette" };
  var MULT_CODE = { berline: "0", vus: "25", camionnette: "50" };
  var HORIZON_JOURS = (B.cfg.horizon && B.cfg.horizon.parForfait && B.cfg.horizon.parForfait[ENTRETIEN ? "ent_1mois" : "cc_remise"]) || 60;
  var MAX_LOT = ENTRETIEN ? 1 : 3;   /* entretien : un vehicule a la fois, avec son heure (2026-09-08) */
  var FENETRE = 60;
  var JOURS = ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"];
  var MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
  var MOIS_COURT = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];

  /* ================= Etat ================= */

  var etat = {
    vehicules: [], rdv: [], aujourdhui: B.iso(new Date()),
    selection: {},            /* vehiculeId -> cle de forfait (cc_* ; ou both_bronze / ext_bronze / ent_* / ponctuel) */
    rythme: {},               /* vehiculeId -> 'mensuel' | '2mois', pour une mise a niveau (entretien) */
    transport: ENTRETIEN ? REGLES.transportDefaut : "cueillette",
    date: null,               /* ISO */
    heure: null,              /* minute du jour, entretien seulement (heure de depot) */
    mois: new Date(),
    envoi: false
  };

  var $ = function (id) { return document.getElementById(id); };
  var el = {};
  ["ccEtatCharge", "ccErreur", "ccBlocResa", "ccVehicules", "ccAjouterBtn", "ccAjoutForm", "ccAjoutAnnuler",
   "ccTransport", "ccCalNote", "ccCalendrier", "ccMois", "ccPrec", "ccSuiv", "ccGrille", "ccRecap",
   "ccResaAlerte", "ccResaSucces", "ccConfirmer", "ccBlocPassages", "ccPassagesNote", "ccPassages", "ccHeures", "ccHeuresNote",
   "ccBlocReleve", "ccReleve"].forEach(function (id) { el[id] = $(id); });
  /* Depuis le 2026-09-08, Liquid rend le transport, le calendrier et le recap
     pour les trois types ; on constate leur presence, rien de plus. */
  var RESERVE = !!(el.ccConfirmer && el.ccGrille && el.ccRecap);
  /* Entretien : les libelles et la preselection du transport suivent les regles. */
  function rendreTransport() {
    if (!ENTRETIEN || !el.ccTransport) return;
    var bd = $("ccDepotBtn"), bc = $("ccCueilletteBtn");
    if (bd) bd.textContent = "Vous nous apportez le véhicule";
    if (bc) bc.textContent = "On vient le chercher et on le ramene (+" + REGLES.supplementCueillette + " $ / véhicule)".replace("ramene", "ramène");
    Array.prototype.forEach.call(el.ccTransport.querySelectorAll("button[data-t]"), function (x) { x.classList.toggle("on", x.dataset.t === etat.transport); });
  }
  rendreTransport();

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function montrerErreur(txt) {
    var e = $("ccErreur");
    if (!e) return;
    e.textContent = txt; e.hidden = false;
  }
  function dateLisible(iso) {
    var d = new Date(iso + "T12:00:00");
    return JOURS[d.getDay()] + " " + d.getDate() + " " + MOIS_COURT[d.getMonth()] + " " + d.getFullYear();
  }
  /* NIV sur la carte : les 8 derniers caracteres, ceux qu'une concession lit. */
  function nivCourt(v) { return v.niv ? ' <span title="' + esc(v.niv) + '" style="opacity:.7">· NIV …' + esc(String(v.niv).slice(-8)) + '</span>' : ""; }
  function argent(n) { return (Math.round(n * 100) / 100).toLocaleString("fr-CA") + " $"; }

  /* ================= Le postier ================= */

  function postier(charge) { return B.envoyerAvecReprises(charge); }

  function charger() {
    /* `entreprise` n'est envoye que si ce n'est pas celle par defaut. Le postier
       verifie qu'elle appartient a la liste du compte et retombe sur la
       premiere sinon — meme regle qu'ici, ecrite deux fois parce que le
       navigateur ne decide rien. */
    var demandeEtat = { action: "concession_etat", clientId: String(C.id).replace(/\D/g, ""), courriel: C.courriel };
    if (AUTRE) demandeEtat.entreprise = C.concession.gid;
    return postier(demandeEtat)
      .then(function (r) {
        if (!r || !r.ok) throw new Error((r && r.erreur) || "réponse vide");
        etat.vehicules = (r.vehicules || []).filter(function (v) { return v.statut !== "vendu"; });
        etat.rdv = r.rdv || [];
        etat.aujourdhui = r.aujourdhui || etat.aujourdhui;
        if (r.regles) { lireRegles(r.regles); rendreTransport(); }
        /* Une selection qui pointe vers un vehicule disparu tombe. */
        Object.keys(etat.selection).forEach(function (id) {
          if (!etat.vehicules.some(function (v) { return v.id === id; })) delete etat.selection[id];
        });
        el.ccEtatCharge.hidden = true;
        el.ccBlocResa.hidden = false;
        el.ccBlocPassages.hidden = false;
        el.ccBlocReleve.hidden = false;
        rendreTout();
      })
      .catch(function (err) {
        el.ccEtatCharge.hidden = true;
        montrerErreur("Impossible de charger votre inventaire : " + err.message + ". Rechargez la page, ou appelez-nous au 418 808-6352.");
      });
  }

  /* ================= Vehicules ================= */

  function livraisonOuverte(v) {
    return !!v.limiteLivraison && v.limiteLivraison >= etat.aujourdhui;
  }
  /* Entretien : la fenetre de passage. Le postier v5 renvoie limitePassage ;
     un postier plus ancien ne la renvoie pas, alors on la deduit ici des
     memes dates, avec la meme regle. */
  function limitePassageDe(v) {
    if (v.limitePassage) return v.limitePassage;
    var dates = [v.dernierPassage, v.derniereRemise].filter(function (x) { return /^\d{4}-\d{2}-\d{2}$/.test(String(x || "")); });
    if (!dates.length) return "";
    var d = new Date(dates.sort().pop() + "T12:00:00");
    d.setDate(d.getDate() + REGLES.passageMaxJours);
    return B.iso(d);
  }
  function passageOuvert(v) {
    var lim = limitePassageDe(v);
    return !!lim && lim >= etat.aujourdhui;
  }
  /* Le prix affiche sur un bouton de carte : base + supplement, sans le depot
     (le depot se voit au recap, ou il s'applique a tout le lot). */
  function prixBouton(v, f) {
    return argent(prixBase(f) + (SUPP[v.format] || 0));
  }
  function prixBase(f) {
    if (!ENTRETIEN) return PRIX[f] || 0;
    var d = decrire(f);
    if (!d) return 0;
    if (d.genre === "maj") return PRIX_ENT.maj[d.formule] || 0;
    if (d.genre === "passage") return (PRIX_ENT[d.rythme] || {})[d.formule] || 0;
    return PRIX_PONCTUEL[f] || 0;
  }

  /* La carte d'un vehicule d'entretien (flotte / bureau). */
  function carteEntretien(v, choix) {
    var ouvert = passageOuvert(v);
    var lim = limitePassageDe(v);
    var enRegime = !!(v.formule && v.regime);
    var badges = '<span class="cc-badge">' + esc(FORMATS[v.format] || v.format) + '</span> ' +
      (v.formule ? '<span class="cc-badge">' + esc(NOMS_FORMULE[v.formule] || v.formule) + (v.regime ? " · " + esc(NOMS_RYTHME[v.regime] || v.regime) : "") + '</span> ' : "") +
      (ouvert
        ? '<span class="cc-badge ok">Passage possible jusqu\'au ' + esc(dateLisible(lim)) + '</span>'
        : '<span class="cc-badge non">' + (lim ? "Fenêtre fermée — mise à niveau" : "Mise à niveau requise") + '</span>');
    var boutons = "";
    if (ouvert && enRegime) {
      var kp = cleDePassage(v.formule, v.regime);
      boutons += '<button type="button" data-f="' + kp + '"' + (choix === kp ? ' class="on"' : "") + '>Passage ' + esc(NOMS_RYTHME[v.regime]) + ' · ' + prixBouton(v, kp) + '</button>';
    } else {
      var formules = v.formule ? [v.formule] : ["int_ext", "ext"];
      formules.forEach(function (fo) {
        var k = fo === "ext" ? "ext_bronze" : "both_bronze";
        boutons += '<button type="button" data-f="' + k + '"' + (choix === k ? ' class="on"' : "") + '>Mise à niveau ' + esc(NOMS_FORMULE[fo]) + ' · ' + prixBouton(v, k) + '</button>';
      });
    }
    /* Le rythme se choisit avec la mise a niveau, quand le vehicule n'en a pas. */
    var dc = choix ? decrire(choix) : null;
    var rythmeUI = "";
    if (dc && dc.genre === "maj" && !v.regime) {
      var r = etat.rythme[v.id] || "mensuel";
      rythmeUI = '<div class="cc-choix" style="margin-top:8px"><span class="cc-sous" style="align-self:center">Ensuite :</span>' +
        '<button type="button" data-r="mensuel"' + (r === "mensuel" ? ' class="on"' : "") + '>chaque mois · ' + argent(PRIX_ENT.mensuel[dc.formule] + (SUPP[v.format] || 0)) + '</button>' +
        '<button type="button" data-r="2mois"' + (r === "2mois" ? ' class="on"' : "") + '>aux 2 mois · ' + argent(PRIX_ENT["2mois"][dc.formule] + (SUPP[v.format] || 0)) + '</button></div>';
    }
    /* Le ponctuel : entre deux cycles, ou pour un vehicule qu'on ne met pas en regime. */
    var estPonctuel = dc && dc.genre === "ponctuel";
    var ponctuel = '<select class="cc-ponctuel" data-p>' +
      '<option value="">Passage ponctuel, prix plein (facultatif)…</option>' +
      Object.keys(PRIX_PONCTUEL).map(function (k) {
        return '<option value="' + k + '"' + (choix === k && estPonctuel ? " selected" : "") + '>' + esc(NOMS_PONCTUEL[k]) + ' · ' + prixBouton(v, k) + '</option>';
      }).join("") + '</select>';
    return badges + '<div class="cc-choix">' + boutons + '</div>' + rythmeUI + ponctuel;
  }

  function rendreVehicules() {
    if (!etat.vehicules.length) {
      el.ccVehicules.innerHTML = '<div class="cc-vide" style="grid-column:1/-1"><b>' + (ENTRETIEN ? "Aucun véhicule activé." : "Aucun véhicule en inventaire.") + '</b>' +
        (ENTRETIEN ? 'Activez votre premier véhicule avec le bouton ci-dessous — la plaque ou un numéro d\'unité suffit.'
                   : 'Ajoutez votre première unité avec le bouton ci-dessous — le numéro de stock suffit.') + '</div>';
      return;
    }
    el.ccVehicules.innerHTML = etat.vehicules.map(function (v) {
      var choix = etat.selection[v.id] || null;
      var ouverte = livraisonOuverte(v);
      var titre = v.etiquette || [v.marque, v.modele, v.annee].filter(Boolean).join(" ") || FORMATS[v.format] || "Véhicule";
      titre = titre.replace(/\s+—\s+stock\s+.*$/i, "");
      if (ENTRETIEN) {
        return '<div class="cc-carte' + (choix ? " on" : "") + '" data-id="' + esc(v.id) + '">' +
          '<div class="cc-stock">' + esc(v.plaque ? "Plaque " + v.plaque : "Unité " + (v.stock || "?")) + nivCourt(v) + '</div>' +
          '<h3>' + esc(titre) + '</h3>' +
          '<div>' + carteEntretien(v, choix) + '</div>' +
        '</div>';
      }
      return '<div class="cc-carte' + (choix ? " on" : "") + '" data-id="' + esc(v.id) + '">' +
        '<div class="cc-stock">Stock ' + esc(v.stock || "?") + nivCourt(v) + '</div>' +
        '<h3>' + esc(titre) + '</h3>' +
        '<div><span class="cc-badge">' + esc(FORMATS[v.format] || v.format) + '</span> ' +
          (ouverte
            ? '<span class="cc-badge ok">Livraison possible jusqu\'au ' + esc(dateLisible(v.limiteLivraison)) + '</span>'
            : '<span class="cc-badge non">' + (v.derniereRemise ? "Fenêtre Livraison fermée" : "Remise à neuf requise") + '</span>') +
        '</div>' +
        (RESERVE ? '<div class="cc-choix">' +
          '<button type="button" data-f="cc_remise"' + (choix === "cc_remise" ? ' class="on"' : "") + '>Remise à neuf · ' + argent(PRIX.cc_remise + (SUPP[v.format] || 0)) + '</button>' +
          '<button type="button" data-f="cc_livraison"' + (choix === "cc_livraison" ? ' class="on"' : "") + (ouverte ? "" : " disabled") +
            ' title="' + (ouverte ? "" : "Remise à neuf chez nous depuis moins de 60 jours requise") + '">Livraison · ' + argent(PRIX.cc_livraison + (SUPP[v.format] || 0)) + '</button>' +
        '</div>' : "") +
      '</div>';
    }).join("");
  }

  function choisir(id, f) {
    if (etat.selection[id] === f) { delete etat.selection[id]; }
    else {
      if (!etat.selection[id] && Object.keys(etat.selection).length >= MAX_LOT) {
        if (ENTRETIEN) { etat.selection = {}; }   /* un vehicule a la fois : le nouveau remplace l'ancien */
        else { alerteResa("Pas plus de " + MAX_LOT + " véhicules par journée en ligne. Pour un plus gros lot, appelez-nous au 418 808-6352."); return; }
      }
      etat.selection[id] = f;
    }
    etat.date = null; etat.heure = null;
    effacerAlertes();
    rendreTout();
  }
  el.ccVehicules.addEventListener("change", function (ev) {
    var sel = ev.target.closest("select[data-p]");
    if (!RESERVE || !sel) return;
    var carte = sel.closest(".cc-carte");
    var id = carte && carte.dataset.id;
    if (!id) return;
    if (!sel.value) { if (etat.selection[id] && decrire(etat.selection[id]) && decrire(etat.selection[id]).genre === "ponctuel") delete etat.selection[id]; etat.date = null; rendreTout(); return; }
    if (etat.selection[id] === sel.value) return;
    if (!etat.selection[id] && Object.keys(etat.selection).length >= MAX_LOT) {
      if (ENTRETIEN) { etat.selection = {}; }
      else { alerteResa("Pas plus de " + MAX_LOT + " véhicules par journée en ligne. Pour un plus gros lot, appelez-nous au 418 808-6352."); sel.value = ""; return; }
    }
    etat.selection[id] = sel.value; etat.date = null; etat.heure = null; effacerAlertes(); rendreTout();
  });
  el.ccVehicules.addEventListener("click", function (ev) {
    var r = ev.target.closest("button[data-r]");
    if (RESERVE && r) {
      var carteR = r.closest(".cc-carte");
      if (carteR && carteR.dataset.id) { etat.rythme[carteR.dataset.id] = r.dataset.r; rendreTout(); }
      return;
    }
    var b = ev.target.closest("button[data-f]");
    if (!RESERVE || !b || b.disabled) return;
    var carte = b.closest(".cc-carte");
    var id = carte && carte.dataset.id;
    if (!id) return;
    var f = b.dataset.f;
    if (ENTRETIEN) { choisir(id, f); return; }
    if (etat.selection[id] === f) { delete etat.selection[id]; }
    else {
      if (!etat.selection[id] && Object.keys(etat.selection).length >= MAX_LOT) {
        alerteResa("Pas plus de " + MAX_LOT + " véhicules par journée en ligne. Pour un plus gros lot, appelez-nous au 418 808-6352.");
        return;
      }
      etat.selection[id] = f;
    }
    etat.date = null;
    effacerAlertes();
    rendreTout();
  });

  /* ================= Le NIV (2026-09-23, demande d'Alex) =================
     Tape ou scanne sur l'etiquette de la portiere du conducteur, le NIV remplit
     marque / modele / annee et SUGGERE le format. Le format fixe le prix : il
     n'est jamais verrouille, le client le confirme. La couleur n'est pas dans
     le NIV.
     - Validation : le 9e caractere est un chiffre de controle, obligatoire en
       Amerique du Nord. Une faute de frappe ou une mauvaise lecture du scan
       echoue ici, AVANT tout appel — on n'enregistre jamais un faux NIV.
     - Decodage : API vPIC de la NHTSA, gratuite, sans cle, CORS ouvert
       (Access-Control-Allow-Origin: *, verifie le 2026-09-23). Si elle tombe,
       le formulaire reste utilisable a la main.
     - Scan : BarcodeDetector natif quand il lit le code_39 (Chrome Android),
       sinon ZXing charge a la demande (iPhone : Safari n'a pas de lecteur
       natif). ~395 Ko, jamais charges tant qu'on n'appuie pas sur le bouton.
       L'etiquette porte du Code 39 ; les recentes, parfois un QR ou DataMatrix
       avec d'autres infos autour — on extrait le premier NIV VALIDE du texte. */
  var NIV_ZXING = "https://cdn.jsdelivr.net/npm/@zxing/browser@0.1.5/umd/zxing-browser.min.js";
  var NIV_TRANS = { A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9, S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9 };
  var NIV_POIDS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
  function nivValide(n) {
    if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(n)) return false;
    var s = 0;
    for (var i = 0; i < 17; i++) {
      var c = n.charAt(i);
      s += (/\d/.test(c) ? +c : NIV_TRANS[c]) * NIV_POIDS[i];
    }
    var r = s % 11;
    return n.charAt(8) === (r === 10 ? "X" : String(r));
  }
  /* Du texte brut (saisie, Code 39, QR) au NIV : majuscules, sans espaces ;
     un Code 39 d'importation porte un « I » de tete (18 caracteres). */
  function nivExtraire(brut) {
    var t = String(brut || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    if (t.length === 18 && t.charAt(0) === "I" && nivValide(t.slice(1))) return t.slice(1);
    if (nivValide(t)) return t;
    var m = String(brut || "").toUpperCase().match(/[A-HJ-NPR-Z0-9]{17}/g) || [];
    for (var i = 0; i < m.length; i++) if (nivValide(m[i])) return m[i];
    return "";
  }
  function nivEtat(txt, genre) {
    var e = $("ccNivEtat");
    if (!e) return;
    e.textContent = txt || " ";
    e.className = "cc-niv-etat large" + (genre ? " " + genre : "");
    e.hidden = !txt;
  }
  function nivMarque(s) {
    s = String(s || "").trim();
    if (!s || /^(BMW|GMC|MINI)$/i.test(s)) return s.toUpperCase();
    return s.toLowerCase().replace(/(^|[\s-])([a-z])/g, function (a, b, c) { return b + c.toUpperCase(); });
  }
  /* Carrosserie vPIC -> nos trois formats. Pickup, fourgonnette, minifourgonnette
     et tout vehicule a 7 places ou 3 rangees -> camionnette (feuille D1 :
     « camionnette / 7 places ») ; VUS, multisegment -> vus ; le reste -> berline. */
  function nivFormat(r) {
    var b = String(r.BodyClass || "").toLowerCase();
    var places = parseInt(r.Seats, 10) || 0, rangees = parseInt(r.SeatRows, 10) || 0;
    if (/pickup|van/.test(b) || places >= 7 || rangees >= 3) return "camionnette";
    if (/sport utility|suv|crossover|cuv|mpv/.test(b)) return "vus";
    if (b) return "berline";
    return "";
  }
  var nivDernier = "";
  function nivDecoder(n) {
    if (n === nivDernier) return;
    nivDernier = n;
    var f = el.ccAjoutForm;
    var deja = etat.vehicules.filter(function (v) { return v.niv && String(v.niv).toUpperCase() === n && v.statut !== "vendu"; })[0];
    if (deja) { nivEtat("Ce NIV est déjà dans votre inventaire (" + (ENTRETIEN ? "unité " : "stock ") + (deja.stock || "?") + ").", "non"); return; }
    nivEtat("NIV valide — recherche du véhicule…", "ok");
    fetch("https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/" + n + "?format=json")
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (d) {
        if (n !== nivDernier) return;
        var r = (d && d.Results && d.Results[0]) || {};
        var marque = nivMarque(r.Make), modele = String(r.Model || "").trim(), annee = String(r.ModelYear || "").trim();
        if (!marque && !modele) { nivEtat("NIV valide, mais le véhicule n'est pas reconnu — complétez à la main.", ""); return; }
        if (marque) f.marque.value = marque.slice(0, 40);
        if (modele) f.modele.value = modele.slice(0, 40);
        if (/^(19|20)\d{2}$/.test(annee)) f.annee.value = annee;
        var fmt = nivFormat(r);
        if (fmt) f.format.value = fmt;
        nivEtat([marque, modele, annee].filter(Boolean).join(" ") +
          (fmt ? " · format suggéré : " + FORMATS[fmt] + " — vérifiez-le, il fixe le prix" : "") + ".", "ok");
        (ENTRETIEN ? f.stock : (f.stock.value ? f.couleur : f.stock)).focus();
      })
      .catch(function () {
        if (n !== nivDernier) return;
        nivEtat("NIV valide. Le décodage automatique ne répond pas — complétez à la main.", "");
      });
  }
  function nivSurSaisie() {
    var inp = $("ccNiv");
    var brut = inp.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    if (!brut) { nivDernier = ""; nivEtat("", ""); return; }
    var n = nivExtraire(brut);
    if (n) { if (inp.value !== n) inp.value = n; nivDecoder(n); return; }
    nivDernier = "";
    if (brut.length < 17) nivEtat(brut.length + " / 17 caractères", "");
    else if (/[IOQ]/.test(brut)) nivEtat("Un NIV ne contient jamais I, O ni Q — c'est sûrement un 1 ou un 0.", "non");
    else nivEtat("Ce NIV ne passe pas la vérification — une lettre ou un chiffre est mal lu.", "non");
  }

  /* ---- Le scan ---- */
  var scan = { flux: null, zx: null, boucle: 0 };
  function scanArreter() {
    if (scan.boucle) { cancelAnimationFrame(scan.boucle); scan.boucle = 0; }
    if (scan.zx) { try { scan.zx.stop(); } catch (e) {} scan.zx = null; }
    if (scan.flux) { scan.flux.getTracks().forEach(function (t) { t.stop(); }); scan.flux = null; }
    var v = $("ccScanVideo"); if (v) v.srcObject = null;
    var b = $("ccScan"); if (b) b.hidden = true;
  }
  function scanTrouve(brut) {
    var n = nivExtraire(brut);
    if (!n) return false;            /* mauvaise lecture : on continue de viser */
    scanArreter();
    if (navigator.vibrate) navigator.vibrate(60);
    $("ccNiv").value = n;
    nivSurSaisie();
    return true;
  }
  function chargerZxing() {
    if (window.ZXingBrowser) return Promise.resolve(window.ZXingBrowser);
    return new Promise(function (ok, ko) {
      var s = document.createElement("script");
      s.src = NIV_ZXING; s.async = true;
      s.onload = function () { window.ZXingBrowser ? ok(window.ZXingBrowser) : ko(new Error("lecteur absent")); };
      s.onerror = function () { ko(new Error("lecteur non chargé")); };
      document.head.appendChild(s);
    });
  }
  /* Haute resolution : le Code 39 d'une portiere est long et fin. */
  var SCAN_VIDEO = { video: { facingMode: { ideal: "environment" }, width: { ideal: 1920 }, height: { ideal: 1080 } }, audio: false };
  function scanDemarrer() {
    var boite = $("ccScan"), video = $("ccScanVideo");
    boite.hidden = false;
    nivEtat("Ouverture de la caméra…", "");
    var natif = ("BarcodeDetector" in window && window.BarcodeDetector.getSupportedFormats)
      ? window.BarcodeDetector.getSupportedFormats().then(function (f) { return f.indexOf("code_39") >= 0 ? f : null; }).catch(function () { return null; })
      : Promise.resolve(null);
    natif.then(function (formats) {
      if (formats) {
        var voulus = ["code_39", "qr_code", "data_matrix", "code_128", "pdf417"].filter(function (x) { return formats.indexOf(x) >= 0; });
        var det = new window.BarcodeDetector({ formats: voulus });
        return navigator.mediaDevices.getUserMedia(SCAN_VIDEO).then(function (flux) {
          scan.flux = flux; video.srcObject = flux;
          return video.play().then(function () {
            nivEtat("Visez le code-barres…", "");
            var occupe = false;
            (function tour() {
              if (!scan.flux) return;
              if (!occupe && video.readyState >= 2) {
                occupe = true;
                det.detect(video).then(function (codes) {
                  occupe = false;
                  for (var i = 0; i < codes.length; i++) if (scanTrouve(codes[i].rawValue)) return;
                }).catch(function () { occupe = false; });
              }
              scan.boucle = requestAnimationFrame(tour);
            })();
          });
        });
      }
      return chargerZxing().then(function (ZX) {
        if (!$("ccScan") || $("ccScan").hidden) return;     /* ferme pendant le chargement */
        var lecteur = new ZX.BrowserMultiFormatReader();
        nivEtat("Visez le code-barres…", "");
        return lecteur.decodeFromConstraints(SCAN_VIDEO, video, function (res) {
          if (res) scanTrouve(res.getText());
        }).then(function (ctrl) { scan.zx = ctrl; if ($("ccScan").hidden) scanArreter(); });
      });
    }).catch(function (err) {
      scanArreter();
      var refus = err && (err.name === "NotAllowedError" || err.name === "SecurityError");
      nivEtat(refus ? "Caméra refusée — autorisez-la dans le navigateur, ou tapez le NIV."
                    : "Caméra indisponible (" + (err && err.message || "erreur") + ") — tapez le NIV.", "non");
    });
  }
  (function brancherNiv() {
    var inp = $("ccNiv"), btn = $("ccScanBtn"), fermer = $("ccScanFermer");
    if (!inp) return;
    inp.addEventListener("input", nivSurSaisie);
    /* Le bouton : telephone ou tablette (pointeur tactile) ET une camera possible. */
    var tactile = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
    if (btn && tactile && navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.isSecureContext) {
      btn.hidden = false;
      btn.addEventListener("click", function () { if ($("ccScan").hidden) scanDemarrer(); else scanArreter(); });
    }
    if (fermer) fermer.addEventListener("click", function () { scanArreter(); nivEtat("", ""); });
  })();

  /* ---- Ajouter un vehicule ---- */
  el.ccAjouterBtn.addEventListener("click", function () {
    el.ccAjoutForm.hidden = !el.ccAjoutForm.hidden;
    if (!el.ccAjoutForm.hidden) ($("ccNiv") || el.ccAjoutForm.querySelector('[name="stock"]')).focus();
    else scanArreter();
  });
  el.ccAjoutAnnuler.addEventListener("click", function () {
    scanArreter(); nivDernier = ""; nivEtat("", "");
    el.ccAjoutForm.hidden = true; el.ccAjoutForm.reset();
  });
  el.ccAjoutForm.addEventListener("submit", function (ev) {
    ev.preventDefault();
    var f = el.ccAjoutForm;
    var v = {
      stock: f.stock.value.trim(), format: f.format.value, marque: f.marque.value.trim(),
      modele: f.modele.value.trim(), annee: f.annee.value.trim(), couleur: f.couleur.value.trim()
    };
    /* NIV facultatif, mais jamais faux : vide, ou valide au chiffre de controle. */
    if (f.niv && f.niv.value.trim()) {
      var n = nivExtraire(f.niv.value);
      if (!n) { nivSurSaisie(); f.niv.focus(); return; }
      v.niv = n;
    }
    if (f.plaque)  v.plaque  = f.plaque.value.trim();
    if (f.formule && f.formule.value) v.formule = f.formule.value;
    if (f.regime  && f.regime.value)  v.regime  = f.regime.value;
    /* Entretien : ni stock ni plaque -> le postier numerote l'unite lui-meme. */
    if (!v.stock && !ENTRETIEN) { f.stock.focus(); return; }
    var btn = f.querySelector('button[type="submit"]');
    btn.disabled = true; btn.textContent = "Enregistrement…";
    postier({ action: "vehicule_ajouter", clientId: String(C.id).replace(/\D/g, ""), vehicule: v })
      .then(function (r) {
        if (!r || !r.ok) throw new Error((r && r.erreur) || "réponse vide");
        f.reset(); f.hidden = true; nivDernier = ""; nivEtat("", "");
        return charger();
      })
      .catch(function (err) { montrerErreur("Véhicule non ajouté : " + err.message); })
      .then(function () { btn.disabled = false; btn.textContent = "Enregistrer le véhicule"; });
  });

  /* ---- Transport ---- */
  if (el.ccTransport) el.ccTransport.addEventListener("click", function (ev) {
    var b = ev.target.closest("button[data-t]");
    if (!b) return;
    etat.transport = b.dataset.t;
    Array.prototype.forEach.call(el.ccTransport.querySelectorAll("button"), function (x) { x.classList.toggle("on", x === b); });
    rendreRecap();
  });

  /* ================= Le lot : heures-personne et prix ================= */

  function vehiculeParId(id) {
    for (var i = 0; i < etat.vehicules.length; i++) if (etat.vehicules[i].id === id) return etat.vehicules[i];
    return null;
  }
  function multiplicateur(format) {
    var m = B.cfg.multiplicateurVehicule || {};
    var k = MULT_CODE[format] || "0";
    return typeof m[k] === "number" ? m[k] : 1;
  }
  /* Les heures-personne d'un vehicule du lot, au PIRE cas (max) et au mieux
     (min) — meme regle que le panneau : le calendrier bloque au pire cas. */
  function hpDe(v, forfait) {
    var d = (B.cfg.durees || {})[forfait];
    if (!d) return { min: 0, max: 0 };
    var mult = multiplicateur(v.format);
    return { min: Math.round(d.min * mult * 100) / 100, max: Math.round(d.max * mult * 100) / 100 };
  }
  function prixDe(v, forfait) {
    var p = prixBase(forfait) + (SUPP[v.format] || 0);
    if (etat.transport === "depot") p -= rabaisDepotDe(forfait);
    if (ENTRETIEN && etat.transport === "cueillette") p += REGLES.supplementCueillette;
    return p;
  }
  function lot() {
    var lignes = [];
    Object.keys(etat.selection).forEach(function (id) {
      var v = vehiculeParId(id);
      if (!v) return;
      var f = etat.selection[id];
      lignes.push({ v: v, forfait: f, hp: hpDe(v, f), prix: prixDe(v, f) });
    });
    lignes.sort(function (a, b) { return String(a.v.stock).localeCompare(String(b.v.stock)); });
    var hpMax = 0, hpMin = 0, total = 0;
    lignes.forEach(function (l) { hpMax += l.hp.max; hpMin += l.hp.min; total += l.prix; });
    return { lignes: lignes, hpMax: Math.round(hpMax * 100) / 100, hpMin: Math.round(hpMin * 100) / 100, total: total };
  }

  /* ================= Calendrier ================= */

  function limiteHaute() {
    var d = new Date(); d.setDate(d.getDate() + HORIZON_JOURS); d.setHours(23, 59, 59, 999);
    return d;
  }
  /* Le delai minimum se compte jusqu'a l'OUVERTURE du jour choisi (l'heure du
     convoi), comme le panneau le compte jusqu'au depot. */
  function debutDuJour(d) {
    var o = B.ouvertureDu(d);
    var min = (o && o.length) ? B.minutes(o[0]) : 9 * 60;
    var x = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
    x.setMinutes(min);
    return x;
  }
  function jourPossible(d, besoinMax) {
    if (d > limiteHaute()) return false;
    if (B.estFerme(d) || B.estBloque(d)) return false;
    if (!(B.capaciteJour(d) > 0)) return false;
    if (ENTRETIEN) {
      /* Comme un client : une place, assez d'heures, et au moins un creneau de
         depot qui tient (delai minimum, fermeture, plages deja prises). */
      if (B.placesRestantes && B.placesRestantes(d) <= 0) return false;
      if (B.heuresRestantes(d) < besoinMax) return false;
      return !!(B.creneaux && B.creneaux(d, besoinMax).length);
    }
    if (debutDuJour(d) < B.limiteBasse()) return false;
    return B.heuresRestantes(d) >= besoinMax - 0.001;
  }

  /* Entretien : les heures de depot du jour choisi, celles du panneau public. */
  function rendreHeures() {
    if (!RESERVE || !ENTRETIEN || !el.ccHeures) return;
    var L = lot();
    if (!etat.date || !L.lignes.length) { el.ccHeures.hidden = true; if (el.ccHeuresNote) el.ccHeuresNote.hidden = true; return; }
    var d = new Date(etat.date + "T12:00:00");
    var options = B.creneaux ? B.creneaux(d, L.hpMax) : [];
    if (!options.length) { el.ccHeures.hidden = true; return; }
    if (etat.heure !== null && options.indexOf(etat.heure) === -1) etat.heure = null;
    el.ccHeures.hidden = false;
    if (el.ccHeuresNote) el.ccHeuresNote.hidden = false;
    el.ccHeures.innerHTML = options.map(function (t) {
      return '<button type="button" data-min="' + t + '"' + (etat.heure === t ? ' class="on"' : "") + ">" + B.hhmm(t).replace(":", " h ") + "</button>";
    }).join("");
  }
  if (el.ccHeures) el.ccHeures.addEventListener("click", function (ev) {
    var b = ev.target.closest("button[data-min]");
    if (!b) return;
    etat.heure = parseInt(b.dataset.min, 10);
    effacerAlertes();
    rendreHeures(); rendreRecap();
  });

  function rendreCalendrier() {
    if (!RESERVE) return;
    var L = lot();
    var aucun = !L.lignes.length;
    el.ccCalNote.hidden = !aucun;
    el.ccCalendrier.hidden = aucun;
    if (aucun) return;

    var an = etat.mois.getFullYear(), m = etat.mois.getMonth();
    el.ccMois.textContent = MOIS[m] + " " + an;
    var debutMois = new Date(an, m, 1);
    var maintenantMois = new Date(); maintenantMois.setDate(1); maintenantMois.setHours(0, 0, 0, 0);
    el.ccPrec.disabled = debutMois <= maintenantMois;
    el.ccSuiv.disabled = new Date(an, m + 1, 1) > limiteHaute();

    var h = JOURS.map(function (j) { return '<span class="cc-jn">' + j + "</span>"; }).join("");
    for (var i = 0; i < debutMois.getDay(); i++) h += '<span class="cc-j vide"></span>';
    var nb = new Date(an, m + 1, 0).getDate();
    var possibles = 0;
    for (var j = 1; j <= nb; j++) {
      var d = new Date(an, m, j);
      var iso = B.iso(d);
      var ok = jourPossible(d, L.hpMax);
      if (ok) possibles++;
      var libres = ok ? Math.floor(B.heuresRestantes(d) * 10) / 10 : 0;
      h += '<button type="button" class="cc-j' + (etat.date === iso ? " on" : "") + '" data-d="' + iso + '"' + (ok ? "" : " disabled") + ">" +
        j + (ok && !ENTRETIEN ? "<small>" + libres.toLocaleString("fr-CA") + " h</small>" : "") + "</button>";
    }
    el.ccGrille.innerHTML = h;
    if (!possibles) {
      el.ccGrille.insertAdjacentHTML("beforeend",
        '<div class="cc-sous" style="grid-column:1/-1;margin-top:8px">' + (ENTRETIEN
          ? "Rien de libre ce mois-ci pour ce forfait. Essayez le mois suivant, ou appelez-nous au 418 808-6352."
          : "Rien de libre ce mois-ci pour un lot de " + L.hpMax.toLocaleString("fr-CA") + " heures-personne. Essayez le mois suivant, ou moins de véhicules à la fois.") + "</div>");
    }
    rendreHeures();
  }
  if (el.ccGrille) el.ccGrille.addEventListener("click", function (ev) {
    var b = ev.target.closest("button.cc-j[data-d]");
    if (!b || b.disabled) return;
    etat.date = b.dataset.d;
    etat.heure = null;
    effacerAlertes();
    rendreCalendrier(); rendreRecap();
  });
  if (el.ccPrec) el.ccPrec.addEventListener("click", function () { etat.mois = new Date(etat.mois.getFullYear(), etat.mois.getMonth() - 1, 1); rendreCalendrier(); });
  if (el.ccSuiv) el.ccSuiv.addEventListener("click", function () { etat.mois = new Date(etat.mois.getFullYear(), etat.mois.getMonth() + 1, 1); rendreCalendrier(); });

  /* ================= Recap et envoi ================= */

  function ligne(k, v, cls) { return '<div class="cc-l' + (cls ? " " + cls : "") + '"><span>' + k + "</span><b>" + v + "</b></div>"; }

  function rendreRecap() {
    if (!RESERVE) return;
    var L = lot();
    if (!L.lignes.length) {
      el.ccRecap.innerHTML = ligne("Véhicules", "aucun sélectionné");
      el.ccConfirmer.disabled = true;
      return;
    }
    var h = L.lignes.map(function (l) {
      var d = ENTRETIEN ? decrire(l.forfait) : null;
      var apres = (d && d.genre === "maj" && !l.v.regime) ? " · ensuite " + NOMS_RYTHME[etat.rythme[l.v.id] || "mensuel"] : "";
      var etiq = ENTRETIEN ? (l.v.plaque ? "Plaque " + l.v.plaque : "Unité " + (l.v.stock || "?")) : "Stock " + (l.v.stock || "?");
      return ligne(esc(etiq) + ' <span class="cc-sous">' + esc(nomForfait(l.forfait)) + " · " + esc(FORMATS[l.v.format] || l.v.format) + esc(apres) + "</span>", argent(l.prix));
    }).join("");
    var rabaisTotal = 0;
    if (etat.transport === "depot") L.lignes.forEach(function (l) { rabaisTotal += rabaisDepotDe(l.forfait); });
    if (ENTRETIEN) {
      h += ligne("Transport", etat.transport === "depot" ? "vous nous apportez le véhicule" : "on vient le chercher (+" + argent(REGLES.supplementCueillette * L.lignes.length) + ")");
    } else {
      h += ligne("Transport", etat.transport === "depot" ? ("vous déposez" + (rabaisTotal ? " (−" + argent(rabaisTotal) + " au total)" : "")) : "cueillette et retour compris");
    }
    h += ligne("Journée", etat.date ? esc(dateLisible(etat.date)) : '<span class="cc-sous">à choisir</span>');
    if (ENTRETIEN) {
      /* Comme le panneau : l'heure de depot, et une estimation du retour
         calculee par le meme moteur (immobilisation au pire cas). Les
         heures-personne restent a l'interieur — jamais affichees ici. */
      var pret = "";
      if (etat.date && etat.heure !== null) {
        var dj = new Date(etat.date + "T12:00:00");
        var immo = B.immobilisation(dj, etat.heure, L.hpMax);
        if (immo && immo.fin) pret = " · prêt vers " + B.hhmm(immo.fin).replace(":", " h ");
      }
      h += ligne("Dépôt", etat.heure !== null ? esc(B.hhmm(etat.heure).replace(":", " h ") + pret) : '<span class="cc-sous">heure à choisir</span>');
    } else {
      h += ligne("Charge d'atelier", L.hpMin.toLocaleString("fr-CA") + " à " + L.hpMax.toLocaleString("fr-CA") + " h-p");
    }
    h += ligne("Total avant taxes", argent(L.total), "total");
    el.ccRecap.innerHTML = h;
    el.ccConfirmer.disabled = !etat.date || (ENTRETIEN && etat.heure === null) || etat.envoi;
  }

  function alerteResa(txt) { el.ccResaAlerte.textContent = txt; el.ccResaAlerte.hidden = false; }
  function effacerAlertes() { el.ccResaAlerte.hidden = true; el.ccResaSucces.hidden = true; }

  if (el.ccConfirmer) el.ccConfirmer.addEventListener("click", function () {
    if (etat.envoi) return;
    var L = lot();
    if (!L.lignes.length || !etat.date) return;
    effacerAlertes();
    etat.envoi = true;
    el.ccConfirmer.disabled = true;
    el.ccConfirmer.textContent = "Envoi…";

    var d = new Date(etat.date + "T12:00:00");
    var o = B.ouvertureDu(d);
    var heure = (o && o.length) ? o[0] : "09:00";
    if (ENTRETIEN) { if (etat.heure === null) return; heure = B.hhmm(etat.heure); }
    var debutMin = B.minutes(heure);

    var vehicules = L.lignes.map(function (l) {
      /* La duree d'immobilisation, en minutes entieres, calculee par le MEME
         moteur que le panneau — c'est elle qui apparait dans l'agenda. */
      var immo = B.immobilisation(d, debutMin, l.hp.max);
      var duree = immo && immo.heures ? Math.round(immo.heures * 60) : B.DUREE_DEFAUT_MIN;
      var dem = { vehiculeId: l.v.id, forfait: l.forfait, hp: l.hp.max, hpmin: l.hp.min, duree: duree, montant: l.prix };
      if (ENTRETIEN) {
        var dd = decrire(l.forfait);
        if (dd && dd.genre === "maj" && !l.v.regime) dem.regime = etat.rythme[l.v.id] || "mensuel";
      }
      return dem;
    });

    var charge = {
      action: "reserver_lot",
      lot: {
        clientId: String(C.id).replace(/\D/g, ""),
        concessionId: C.concession.gid,
        date: etat.date, heure: heure, transport: etat.transport,
        /* entretien : plage bloquee comme un client ; concession : flottant (le postier tranche par type) */
        flottant: !ENTRETIEN,
        contact: { nom: [C.prenom].filter(Boolean).join(" "), courriel: C.courriel, tel: C.concession.tel || "" },
        vehicules: vehicules
      }
    };

    postier(charge)
      .then(function (r) {
        if (!r) throw new Error("réponse vide");
        if (r.refus && !r.resultats) throw new Error(r.erreur || "refusé");
        var res = r.resultats || [];
        var ok = res.filter(function (x) { return x.ok; });
        var non = res.filter(function (x) { return !x.ok; });
        if (!ok.length) throw new Error(non.length ? non.map(function (x) { return "stock " + (x.stock || "?") + " : " + x.refus; }).join(" · ") : (r.erreur || "refusé"));
        el.ccResaSucces.innerHTML =
          "<b>C'est réservé pour " + esc(dateLisible(etat.date)) + (ENTRETIEN ? ", dépôt à " + esc(heure.replace(":", " h ")) : "") + ".</b> " +
          ok.map(function (x) { return (ENTRETIEN ? "Unité " : "Stock ") + esc(x.stock || "?") + (x.lien ? ' — <a href="' + esc(x.lien) + '">déplacer / annuler</a>' : ""); }).join(" · ") +
          (non.length ? "<br>Non pris : " + non.map(function (x) { return (ENTRETIEN ? "unité " : "stock ") + esc(x.stock || "?") + " (" + esc(x.refus) + ")"; }).join(" ; ") + ". Appelez-nous au 418 808-6352." : "") +
          "<br>Une confirmation vient de partir à " + esc(C.courriel) + ".";
        el.ccResaSucces.hidden = false;
        etat.selection = {}; etat.date = null; etat.heure = null;
        /* Recharger : le cache de capacite du site a change (les heures du
           lot sont prises), et la liste des passages aussi. */
        return charger();
      })
      .catch(function (err) {
        alerteResa("La réservation n'a pas pu être enregistrée : " + err.message + ". Rien n'a été pris. Réessayez, ou appelez-nous au 418 808-6352.");
      })
      .then(function () {
        etat.envoi = false;
        el.ccConfirmer.textContent = "Confirmer la réservation";
        rendreRecap();
      });
  });

  /* ================= Passages et releve ================= */

  function rendrePassages() {
    var aVenir = etat.rdv.filter(function (r) { return r.etat === "a_venir"; })
      .sort(function (a, b) { return a.date < b.date ? -1 : 1; });
    var passes = etat.rdv.filter(function (r) { return r.etat !== "a_venir"; });
    el.ccPassagesNote.textContent = aVenir.length + " à venir · " + passes.length + " passé" + (passes.length > 1 ? "s" : "");
    if (!etat.rdv.length) {
      el.ccPassages.innerHTML = '<div class="cc-vide"><b>Aucun passage encore.</b>Votre première réservation apparaîtra ici, avec son lien pour la déplacer ou l\'annuler.</div>';
      return;
    }
    var rang = function (r) {
      return "<tr><td><b>" + esc(dateLisible(r.date)) + "</b>" + (r.etat === "a_venir" && r.heure ? '<br><span class="cc-sous">' + (ENTRETIEN ? "dépôt à " : "convoi vers ") + esc(r.heure.replace(":", " h ")) + "</span>" : "") + "</td>" +
        "<td>" + esc(r.stock ? (ENTRETIEN ? "Unité " : "Stock ") + r.stock : "—") + "</td>" +
        "<td>" + esc(r.forfaitLisible || r.forfait) + "<br><span class=\"cc-sous\">" + esc(FORMATS[r.vehicule] || r.vehicule) + (r.transport ? " · " + (r.transport === "depot" ? "déposé" : "cueillette") : "") + "</span></td>" +
        "<td>" + (r.montant ? esc(argent(r.montant)) : "—") + "</td>" +
        "<td>" + (r.etat === "a_venir" ? '<span class="cc-badge ok">à venir</span>' : r.etat === "fait" ? '<span class="cc-badge">fait</span>' : '<span class="cc-badge non">annulé</span>') +
          (r.lien ? '<br><a class="cc-lien" href="' + esc(r.lien) + '">déplacer / annuler</a>' : "") + "</td></tr>";
    };
    el.ccPassages.innerHTML = '<table class="cc-table"><thead><tr><th>Journée</th><th>Véhicule</th><th>Forfait</th><th>Prix</th><th>État</th></tr></thead><tbody>' +
      aVenir.concat(passes).map(rang).join("") + "</tbody></table>";
  }

  function rendreReleve() {
    var faits = etat.rdv.filter(function (r) { return r.etat === "fait"; });
    if (!faits.length) {
      el.ccReleve.innerHTML = '<div class="cc-vide"><b>Rien à facturer encore.</b>Chaque passage terminé s\'ajoute ici, regroupé par mois, avant taxes. Le relevé officiel vous parvient au début du mois suivant.</div>';
      return;
    }
    var parMois = {};
    faits.forEach(function (r) {
      var k = String(r.date).slice(0, 7);
      (parMois[k] = parMois[k] || { n: 0, total: 0 });
      parMois[k].n++; parMois[k].total += r.montant || 0;
    });
    var cles = Object.keys(parMois).sort().reverse();
    el.ccReleve.innerHTML = '<table class="cc-table"><thead><tr><th>Mois</th><th>Véhicules</th><th>Total avant taxes</th></tr></thead><tbody>' +
      cles.map(function (k) {
        var p = k.split("-");
        return "<tr><td><b>" + esc(MOIS[+p[1] - 1] + " " + p[0]) + "</b></td><td>" + parMois[k].n + "</td><td>" + esc(argent(parMois[k].total)) + "</td></tr>";
      }).join("") + "</tbody></table>";
  }

  function rendreTout() { rendreVehicules(); rendreCalendrier(); rendreHeures(); rendreRecap(); rendrePassages(); rendreReleve(); }

  var SOUS_TITRE = {
    concessionnaire: "Vos véhicules d'inventaire, vos réservations et votre relevé — sans appel, sans texto.",
    flotte: "Flotte commerciale · entretien au prix du site, mise à niveau une fois puis passages à votre rythme · facturé au véhicule, relevé mensuel.",
    bureau: "Bureau professionnel · entretien au prix du site, mise à niveau une fois puis passages à votre rythme · facturé au véhicule, relevé mensuel."
  };
  var NOMS_TYPE = { concessionnaire: "Concessionnaire", flotte: "Flotte", bureau: "Bureau" };

  /* ---- La barre de choix d'entreprise ---------------------------------------
     N'apparait que si le compte en porte plus d'une. L'en-tete (titre et
     sous-titre) est ecrit par Liquid a partir de l'entreprise PAR DEFAUT : quand
     une autre est choisie il dirait le contraire de ce qui est a l'ecran, donc
     on le reecrit. C'est le seul texte serveur que ce fichier touche.
     ------------------------------------------------------------------------ */
  function poserSelecteurEntreprise() {
    if (ENTREPRISES.length < 2) return;
    var tete = document.querySelector(".page-head");
    if (!tete) return;

    if (AUTRE) {
      var h1 = tete.querySelector("h1");
      if (h1) h1.innerHTML = esc(C.concession.nom || "Votre entreprise") + "<em>.</em>";
      var p = tete.querySelector("p");
      if (p && SOUS_TITRE[TYPE]) p.textContent = SOUS_TITRE[TYPE];
    }

    var barre = document.createElement("div");
    barre.className = "cc-ent";
    barre.innerHTML = '<span class="cc-ent-eti">Vos entreprises</span>' + ENTREPRISES.map(function (e) {
      var actif = e.gid === C.concession.gid;
      var url = (e.gid === DEFAUT.gid)
        ? window.location.pathname
        : window.location.pathname + "?entreprise=" + encodeURIComponent(cleDe(e));
      var t = String(e.type || "concessionnaire").toLowerCase();
      return '<a class="cc-ent-btn' + (actif ? " est-actif" : "") + '" href="' + url + '"'
        + (actif ? ' aria-current="true"' : "") + ">" + esc(e.nom || cleDe(e))
        + ' <span class="cc-ent-type">' + esc(NOMS_TYPE[t] || t) + "</span></a>";
    }).join("");
    tete.appendChild(barre);
  }

  poserSelecteurEntreprise();
  charger();
})();
